import { ILeadsEventConfig, IDualAxisLineGraphConfig } from '../../../../_shared/models/models-index';

export class LeadsEventConfig implements ILeadsEventConfig {
    public graphConfig: IDualAxisLineGraphConfig = null;
    public trendTableMetricKeys: string[] = [];

}
